export default function FAQSection() {
  const faqs = [
    {
      question: '韩国漫画网上的漫画都是免费的吗？',
      answer: '是的，韩国漫画网上的所有漫画资源完全免费阅读。我们致力于为漫画爱好者提供优质的免费漫画大全服务，让每一位读者都能畅享好看的韩国漫画推荐，无需任何付费。',
    },
    {
      question: '什么是无遮挡下拉式阅读模式？',
      answer: '无遮挡下拉式阅读是我们专为韩漫阅读优化的在线阅读体验。与传统的翻页模式不同，下拉式阅读将整话漫画以纵向连续流的方式呈现，读者只需向下滑动即可无缝阅读，没有任何弹窗、广告遮挡，确保在线体验舒适流畅，让您专注于漫画情节本身。',
    },
    {
      question: '网站上的漫画多久更新一次？',
      answer: '我们每天都会更新最新的漫画章节。热门连载作品的更新频率通常与韩国原版同步，确保读者能够第一时间看到最新的韩国漫画内容。您可以收藏喜欢的作品，随时追踪更新动态。',
    },
    {
      question: '如何在手机上阅读韩国漫画？',
      answer: '韩国漫画网完美适配手机端浏览器，您可以直接在手机浏览器中打开我们的网站进行阅读。下拉式阅读模式在手机上体验尤为出色，只需手指滑动即可轻松阅读，无需下载任何App。',
    },
    {
      question: '支持哪些类型的韩国漫画？',
      answer: '我们涵盖恋爱、奇幻、热血、剧情、喜剧、悬疑、日常、耽美等8大分类，数千部韩漫作品。无论你喜欢什么类型的漫画，都能在这里找到心仪的作品。韩国漫画网持续扩充漫画大全资源库。',
    },
    {
      question: '如何找到自己喜欢的漫画？',
      answer: '您可以通过顶部的分类导航浏览不同类型的韩国漫画，也可以使用搜索功能直接查找特定作品。首页的热门推荐和最新更新板块会为您推荐高质量的韩漫作品。',
    },
  ];

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <section className="py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-1">关于韩国漫画网的常见疑问解答</p>
          </div>
          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, index) => (
              <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors duration-200">
                  <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 w-4 h-4 flex items-center justify-center shrink-0"></i>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}